<template>
  <div class="rater" :class="{ small }">
    <div v-for="r in 10"
      class="rater-dot"
      @touchstart="hoveringRaterDot(r)"
      @touchend="hoveringRaterDot(r, true)"
      @mouseover="hoveringRaterDot(r)"
      @mouseout="hoveringRaterDot(r, true)"
      @click="clickRaterDot(r)">
      <div :style="raterDotStyle(r)"></div>
    </div>
    <div class="mt5 rating-hint" v-if="!small">{{ ratingHint }}</div>
  </div>
</template>

<script>
/**
 * Component to select a 'rating' from 1 to 10
 *
 * @vue-prop {Number} value - Rating value
 *
 */

export default {
  name: 'GwRater',
  props: {
    value: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hoverDot: 0,
      colors: ["", "#c60d00","#b61901","#a52601","#953301","#844002","#744c02","#635903","#536603","#427303","#327f04"], // Done using https://codepen.io/BangEqual/pen/VLNowO
      hints: [
        '',
        this.$t('message.REALLY_BAD'),
        this.$t('message.REALLY_BAD'),
        this.$t('message.BAD'),
        this.$t('message.BAD'),
        this.$t('message.NOT_SO_GOOD'),
        this.$t('message.OKAY'),
        this.$t('message.OKAY'),
        this.$t('message.GOOD'),
        this.$t('message.GOOD'),
        this.$t('message.EXCELLENT')
      ],
    };
  },
  computed: {
    ratingHint(relevance) {
      var idx = this.hoverDot !== 0 ? this.hoverDot : this.value;
      return this.hints[idx];
    },
  },
  methods: {
    /** Mouse or finger hover rating dot */
    hoveringRaterDot(idx, out) {
      if (!this.disabled) {
        this.hoverDot = out ? 0 : idx;
      }
    },
    /** Rating dot style */
    raterDotStyle(idx, relevance) {
      var coloredIndex = relevance ?
        Math.max(this.relevanceHoverDot, this.rating.ratingRelevance) :
        Math.max(this.moodHoverDot, this.rating.ratingMood);
      return {
        border: "2px solid " + this.colors[idx],
        backgroundColor: idx <= coloredIndex ? this.colors[idx] : 'transparent'
      }
    },
    /** Grade given */
    clickRaterDot(idx) {
      if (!this.disabled) {
        this.$emit('input', idx);
      }
    },
    /** Rating dot style */
    raterDotStyle(idx) {
      return {
        border: "2px solid " + this.colors[idx],
        backgroundColor: idx <= Math.max(this.hoverDot, this.value) ? this.colors[idx] : 'transparent'
      }
    },
  }
};
</script>

<style scoped>
.rater {
  position: relative;
  display: inline-block;
}
.rater-dot {
  display: inline-block;
  padding: 4px;
  width: 14px;
  height: 14px;
}
.rater-dot {
  cursor: pointer;
}
.rater-dot > div {
  border-radius: 10px;
  width: 10px;
  height: 10px;
}
.rater.small .rater-dot {
  padding: 1px;
  width: 10px;
  height: 10px;
}
.rater.small .rater-dot > div {
  border-radius: 10px;
  width: 6px;
  height: 6px;
}
.rating-hint {
  font-style: italic;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -1.8em;
}
</style>
